import React from 'react'

const InStock = () => {
  return (
    <div className="instock">In Stock</div>
  )
}

export default InStock